import type { UseAccordionProps } from '@chakra-ui/react';

import { useQuoteLock } from './QuoteLockContext';

interface UseLockAwareAccordionProps {
  itemCount: number;
  expandedIndex: number;
  setExpandedIndex: (index: number) => void;
  allowToggle?: boolean;
}

export const useLockAwareAccordion = ({
  itemCount,
  expandedIndex,
  setExpandedIndex,
  allowToggle,
}: UseLockAwareAccordionProps): UseAccordionProps => {
  const { isLocked } = useQuoteLock();

  if (isLocked) {
    return {
      allowMultiple: true,
      index: Array.from({ length: itemCount }, (_, index) => index),
    };
  }

  return {
    allowToggle,
    index: expandedIndex,
    onChange: (index) => setExpandedIndex(index as number),
  };
};
